export default __webpack_public_path__ + "static/media/goopter-retail-store-automation-process.31ea9ff7.png";